class SignupService {
    constructor($rootScope, $q, Restangular, RestangularV3, sessionStorage, loginService, shopperService, analytics) {
        this._api = Restangular.one('signup');
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.sessionStorage = sessionStorage;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.analytics = analytics;
        this._apiV3 = RestangularV3.one('businesscategory');

        this.businessTypes = [];
        this.getBusinessTypes();
    }

    signup(args) {
        const signupPromise = this._api.doPOST(args);

        const shopperPromise = signupPromise.then(signupResult => (signupResult.Success
            ? this.shopperService.getCurrentShopper()
            : null));

        return this.$q.all([signupPromise, shopperPromise])
            .then(([signupResult]) => {
                if (signupResult.Success) {
                    this.redirectToAgentUrl = signupResult.RedirectToAgentUrl;
                    this.analytics.push({ data: { event: 'signup' } });
                    this.loginService.onLogin(signupResult.LoginModel);
                    this.$rootScope.$broadcast('signup:success');
                    // flag to push login and signup user detail to analytics
                    this.sessionStorage.set('shouldTrackSignupEvent', true);
                    this.sessionStorage.set('shouldTrackLoginEvent', true);
                    this.sessionStorage.setJson('ShowRewardsOnboardingSignUp', true);
                }

                return signupResult;
            });
    }

    getBusinessTypes() {
        this._apiV3.one('secondary').get().then((resp) => {
            this.businessTypes = resp.sort();
        });
    }
}

SignupService.$inject = ['$rootScope', '$q', 'Restangular', 'RestangularV3', 'SessionStorageWrapper', 'LoginService', 'ShopperService', 'AnalyticsService'];

module.exports = { SignupService };



// WEBPACK FOOTER //
// ./src/auth/signup/signup.service.js